import { useState, ReactNode } from 'react'

export interface Props {
  title: string
  children: ReactNode
}

export const useFaqItem = (props: Props) => {
  const { title, children } = props
  const [isOpen, setIsOpen] = useState(false)
  const onClickHeader = () => {
    setIsOpen(!isOpen)
  }

  return {
    title,
    children,
    isOpen,
    onClickHeader,
  }
}
